module.exports = __webpack_public_path__ + "static/img/WashingtonOffshore-RA.abf0636.png";